import { type IFormField, type QuestionData } from '../support.type';
import { Question } from './Question';

export class EditableQuestion extends Question {
    constructor(
        question: QuestionData,
        private readonly textField: IFormField<string>
    ) {
        super(question);
    }

    override get value() {
        return this.textField.value ?? '';
    }

    get isRequired() {
        return this.textField.isRequired;
    }

    updateValue(val: string) {
        this.textField.updateValue(val);
    }

    updateCurrentValue() {
        return this.textField.validateCurrentField();
    }

    get isValid() {
        return this.textField.isValid;
    }
}
